import React, {Component} from 'react';

import ff from './ff';
import bf from './bf';
import ic from './ic';
import cf from './cf';
import ce from './ce';
import cr from './cr';

import cView from './cView';

//import c50v from './c50v_20211024';

export default class c51v extends cView {

constructor(props) { // state の宣言だけでは駄目な模様
  super(props);
  this.state = cf.myRN_crt_stss(
    this.$cd_stss,
    this.$id_stss
  );
}

$cd_stss = { // 親を上書き
  sdld_c14rDtlsss: {c14r:[]},
};

/*
static op_loadList = pd => 
  (pd.elm == 'c51r') ?
    super.op_loadList({
      o_cnd: _dd_datss => {
        let _cnd = cf.c('c51r', `c51rc11s = ${pd.c51rc11s}`)
        return _cnd;
      },
      ...pd,
    })
  : super.op_loadList(pd)
;
static op_loadList = pd => 
  (pd.elm == 'c51r') ?
    super.op_loadList({
      elm: 'c50r',
      o_cnd: _d_flds => {
        let _cnd = cf.c('c50r', null, false, false) // 歴管理の対象外
        return _cnd;
      },
      dd_rfrss: {
        c51r: {
          elm: 'c51r',
          o_cnd: _d_flds => {
            let _cnd = cf.c('c51r', `c51rc11s = ${_d_flds.c50rc11s}`)
            return _cnd;
          },
        }
      },
      ...pd,
    })
  : super.op_loadList(pd)
;
*/
static op_loadList = pd => 
  (pd.elm == 'c51r') ?
    super.op_loadList({
      elm: 'c51r',
      o_cnd: _dd_datss => {
        let _cnd = cf.c('c51r');
        if (ff.f(global.t?.state.s_word)) _cnd += ` AND c51rc11s IN (SELECT c50rc11s FROM t_c50r WHERE c50rk11s LIKE "%${global.t?.state.s_word}%" OR c50rc31s LIKE "%${global.t?.state.s_word}%")`
        ff.l('c51v 69: {}'.f(_cnd));
        return _cnd;
      },
      dd_rfrss: {
        c50r: {
          elm: 'c50r',
          o_cnd: _d_flds => {
            let _cnd = cf.c('c50r', `c50rc11s = "${_d_flds.c51rc11s}"`, true, false);
            return _cnd;
          },
        }
      },
      ld_sortss: [
        { fld: 'c50rcx1i', dtn: 'asc', mode: 'nmb'},        
        { fld: 'c50rc11s', dtn: 'asc', mode: 'nmb'},        
      ],
      ...pd,
    })
  : super.op_loadList(pd)
;

static op_loadSlcList = pd => 
  (pd.elm == 'c51r') ?
    super.op_loadSlcList({
      ...pd,
      od_fmts: pd.od_fmts ?? (_d_dats => { // o_getC51ri11s への対応
        let _d = {
          ..._d_dats,
          key: _d_dats.d_flds.c51rc11s,
        };
        if (ic.gb_dbg) bf.l('cView 210: {}'.f(_d_dats.d_flds))
        if (ic.gb_dbg) bf.l('cView 211: {}'.f(_d))
        return _d;
      }),
    })
  : super.op_loadSlcList(pd)
;

static o_getC51ri11s = (p_c51rc11s) => {
  let _d_dats = ff.myCM_getDny({
    ld_iss: global.t?.state.sdld_c51rSlcListsss?.c51r, 
    fld: 'key', 
    val: p_c51rc11s
  });
  return _d_dats?.d_flds?.c51ri11s ?? null;
}; 

static op_loadDtl = pd => 
  (pd.elm == 'c51r') ?
    super.op_loadDtl({
      ...pd,
      dd_rfrss: {
        c50r: {
          elm: 'c50r',
          o_cnd: _d_flds => {
            let _cnd = cf.c('c50r', `c50rc11s = "${_d_flds.c51rc11s}"`, true, false);
//ff.l('c51v 125: {}'.f(_cnd));
            return _cnd;
          },
        }
      },
/*
      op_atrAll: () => new Promise( _o_end1 => {

        let _tdy = ff.myDT_getDate('today');
        let _date0Fst = ff.myDT_add('mth', ff.myDT_cnv('fdm', _tdy), 0);
        let _date1Fst = ff.myDT_add('mth', ff.myDT_cnv('fdm', _tdy), 1);
        let _date2Fst = ff.myDT_add('mth', ff.myDT_cnv('fdm', _tdy), 2);
        let _date3Fst = ff.myDT_add('mth', ff.myDT_cnv('fdm', _tdy), 3);
        let _date0Lst = ff.myDT_cnv('ldm', _date0Fst);
        let _date1Lst = ff.myDT_cnv('ldm', _date1Fst);
        let _date2Lst = ff.myDT_cnv('ldm', _date2Fst);
        let _date3Lst = ff.myDT_cnv('ldm', _date3Fst);
        let _mth0 = ff.myDT_cnv('mth', _date0Fst);
        let _mth1 = ff.myDT_cnv('mth', _date1Fst);
        let _mth2 = ff.myDT_cnv('mth', _date2Fst);
        let _mth3 = ff.myDT_cnv('mth', _date3Fst);
        let _yearMth0 = ff.myDT_cnv('year-mth', _date0Fst);
        let _yearMth1 = ff.myDT_cnv('year-mth', _date1Fst);
        let _yearMth2 = ff.myDT_cnv('year-mth', _date2Fst);
        let _yearMth3 = ff.myDT_cnv('year-mth', _date3Fst);

        c51v1a.op_loadSlcList({
          elm: 'c51r',
          op_atrAll: () => new Promise( _o_end2 => {

            let _rsvSttDate = ff.myDT_add('day', _tdy, bf.n(c51v1a.o_getC51ri11s('01040400'))); // 予約受付終了日

            let _rsvOpenDtm = ff.myDT_add('day', ff.myDT_cnv('fdm', _tdy), bf.n(c51v1a.o_getC51ri11s('01040100')) - 1); // 予約解禁日
            _rsvOpenDtm = `${_rsvOpenDtm} ${c51v1a.o_getC51ri11s('01040200')}:00`

            let _alyThisMth = _mth2; // 今回
            let _alyThisYearMth = _yearMth2; // 今回
            let _alyThisSttDate = ff.myDT_add('day', ff.myDT_cnv('fdm', _tdy), bf.n(c51v1a.o_getC51ri11s('02040100')) - 1); // 予約受付開始日
            let _alyThisEndDate = ff.myDT_add('day', ff.myDT_cnv('fdm', _tdy), bf.n(c51v1a.o_getC51ri11s('02040200')) - 1); // 予約受付終了日
            let _alyNextMth = _mth3; // 次回
            let _alyNextYearMth = _yearMth3; // 次回
            let _alyNextSttDate = ff.myDT_add('day', ff.myDT_cnv('fdm', ff.myDT_add('mth', _tdy, 1)), bf.n(c51v1a.o_getC51ri11s('02040100')) - 1); // 予約受付開始日
            let _alyNextEndDate = ff.myDT_add('day', ff.myDT_cnv('fdm', ff.myDT_add('mth', _tdy, 1)), bf.n(c51v1a.o_getC51ri11s('02040200')) - 1); // 予約受付終了日
            let _alyMsg1 = null;
            let _alyMsg2 = null;
            let _alyMth = null;
            let _alySttDate = null;
            let _alyEndDate = null;
            let _b_alyPrd = false; // apply period
            if ( _tdy < _alyThisSttDate) { // エントリー期間前
              _alyMsg1 = `${_alyThisYearMth} 月分は ${_alyThisSttDate} から受付予定`
              _alyMsg2 = `最大数は、${_alyThisMth}月が${c51v1a.o_getC51ri11s('02040300')}件`;
              _alyMth = _alyThisYearMth;
              _alySttDate = _alyThisSttDate;
              _alyEndDate = _alyThisEndDate;
            }
            else if ( _tdy >= _alyThisSttDate && _tdy <= _alyThisEndDate) { // エントリー期間
              _alyMsg1 = `${_alyThisYearMth} 月分を ${_alyThisEndDate} まで受付中`
              _alyMsg2 = `最大数は、${_alyThisMth}月が${c51v1a.o_getC51ri11s('02040300')}件`;
              _alyMth = _alyThisYearMth;
              _alySttDate = _alyThisSttDate;
              _alyEndDate = _alyThisEndDate;
              _b_alyPrd = true;
            }
            else { // エントリー期間後
              _alyMsg1 = `${_alyNextYearMth} 月分は ${_alyNextSttDate} から受付予定`
              _alyMsg2 = `最大件数は、${_alyNextMth}月が${c51v1a.o_getC51ri11s('02040300')}件`;
              _alyMth = _alyNextYearMth;
              _alySttDate = _alyNextSttDate;
              _alyEndDate = _alyNextEndDate;
            }

            cf.myRN_setStt({
              sgcd_stgs: _next => {
                _next = {
                  ..._next,
                  b_alyPrd: _b_alyPrd,
                  alyMsg1: _alyMsg1,
                  alyMsg2: _alyMsg2,
                  alyMth: _alyMth, // エントリー可能月
                  alySttDate: _alySttDate, // エントリ受付開始日
                  alyEndDate: _alyEndDate, // エントリ受付終了日
                  _00060100: c51v1a.o_getC51ri11s('00060100'), // 利用規約の表記
                  _01010100: c51v1a.o_getC51ri11s('01010100'), // 直接予約一覧画面説明文1
                  _01010200: c51v1a.o_getC51ri11s('01010200'), // 直接予約一覧画面説明文2
                  _01020100: c51v1a.o_getC51ri11s('01020100'), // 直接予約登録画面説明文1（新規）
                  _01020200: c51v1a.o_getC51ri11s('01020200'), // 直接予約登録画面説明文2（新規）
                  _01021100: c51v1a.o_getC51ri11s('01021100'), // 直接予約登録画面説明文1（変更）
                  _01021200: c51v1a.o_getC51ri11s('01021200'), // 直接予約登録画面説明文2（変更）
                  _01022100: c51v1a.o_getC51ri11s('01022100'), // 直接予約登録画面説明文1（閲覧）
                  _01022200: c51v1a.o_getC51ri11s('01022200'), // 直接予約登録画面説明文2（閲覧）
                  _02010100: c51v1a.o_getC51ri11s('02010100'), // エントリー一覧画面説明文1
                  _02010200: c51v1a.o_getC51ri11s('02010200'), // エントリー一覧画面説明文2
                  _02020100: c51v1a.o_getC51ri11s('02020100'), // エントリー登録画面説明文1（新規）
                  _02020200: c51v1a.o_getC51ri11s('02020200'), // エントリー登録画面説明文2（新規）
                  _02021100: c51v1a.o_getC51ri11s('02021100'), // エントリー登録画面説明文1（変更）
                  _02021200: c51v1a.o_getC51ri11s('02021200'), // エントリー登録画面説明文2（変更）
                  _02022100: c51v1a.o_getC51ri11s('02022100'), // エントリー登録画面説明文1（閲覧）
                  _02022200: c51v1a.o_getC51ri11s('02022200'), // エントリー登録画面説明文2（閲覧）
                  _02040300: c51v1a.o_getC51ri11s('02040300'), // エントリー可能最大件数
                }
              }
            })
            .then(() => {
              if (global.t?.state.sgcd_cmnStgs.c10rb31f > 0) {
                c30v1a.op_loadDtl({
                  elm: 'c30r',
                  op_atrAll: () => new Promise( _o_end3 => {
                    if (ff.f(global.t?.state.sdld_c30rDtlsss?.c30r)) {
                      let _d_c30rs = global.t?.state.sdld_c30rDtlsss.c30r[0];
                      let _i15ri11i = _d_c30rs.d_flds.i15ri11i; // 翌々月予約最大件数
                      let _i15ri21i = _d_c30rs.d_flds.i15ri21i; // 翌月予約最大件数
                      let _i15ri31i = _d_c30rs.d_flds.i15ri31i; // 当月予約最大件数
                      let _i15rt32i = _d_c30rs.d_flds.i15rt32i ?? 0; // エントリー申込の可否
                      let _rsvEndDate = 
                        (_d_c30rs.d_flds.i15rt41i == 120) ? // 2週間後
                          ff.myDT_add('day', ff.myDT_getDate('today'), 14)
                        : (_d_c30rs.d_flds.i15rt41i == 130) ? // 3週間後
                          ff.myDT_add('day', ff.myDT_getDate('today'), 21)
                        : (_d_c30rs.d_flds.i15rt41i == 200) ? // 当月末
                          _date0Lst
                        : (_d_c30rs.d_flds.i15rt41i == 210) ? // 一ヶ月後月末
                          _date1Lst
                        : (_d_c30rs.d_flds.i15rt41i == 210) ? // 二ヶ月後月末
                          _date2Lst
                        : (_d_c30rs.d_flds.i15rt41i == 300 && ff.myDT_getNow() < _rsvOpenDtm ) ? // 解禁前
                          _date1Lst
                        : (_d_c30rs.d_flds.i15rt41i == 300 && ff.myDT_getNow() >= _rsvOpenDtm ) ? // 解禁後
                          _date2Lst
                        : null;
                      let _rsvMsg1 = `${_rsvSttDate} から ${_rsvEndDate} までを受付中`;
                      let _rsvMsg2 = `最大数は、${_mth0}月が${_i15ri31i}件、${_mth1}月が${_i15ri21i}件、${_mth2}月が${_i15ri11i}件`;
                      let _d = {
                      };
                      cf.myRN_setStt({
                        sgcd_stgs: _next => {
                          _next = {
                            ..._next,
                            rsvMsg1: _rsvMsg1,
                            rsvMsg2: _rsvMsg2,
                            rsvSttDate: _rsvSttDate, // 予約可能利用開始日
                            rsvEndDate: _rsvEndDate, // 予約可能利用終了日
                            d_rsvMaxCnts: {
                              [_yearMth2]: _i15ri11i, // 翌々月予約可能件数
                              [_yearMth1]: _i15ri21i, // 翌月予約可能件数
                              [_yearMth0]: _i15ri31i, // 当月予約可能件数
                            },
                          };
                        }
                      })
                      .then(_o_end3);
                    }
                    else {
                      _o_end3();
                    };
                  }),
                })
                .then(_o_end2)
              }
              else {
                _o_end2();
              }
            });
          })
        })
        .then(() => {
          _o_end1();
        });
      }),
*/
    })
  : super.op_loadDtl(pd)


$clp_loadLists = () => [ // 親を上書き
/*
  cf.myRN_savePageStgs({
    sgc_pnlMode: 'dtl',
  }),
*/
  c51v.op_loadList({
    elm: 'c51r',
  }),
];

$clp_loadDtls = () => [
  c51v.op_loadDtl({
    elm: 'c51r',
/*
    o_cnd: _dd_datss => {
      let _cnd = cf.c('c51r', `c51rb51k=${global.t?.state.sgc_pageKey}`);
      return _cnd;
    },
    dd_rfrss: {
      c50r: {
        elm: 'c50r',
        o_cnd: _d_flds => {
          let _cnd = cf.c('c50r', `c50rc11s = "${_d_flds.c51rc11s}"`, true, false);
        },
      }
    }
*/
  }),
  c51v.op_loadVsnList({
    elm: 'c51r',
  }),
];

$clp_upds = () => [
  cr.myCB_call_tree({
    ctr: 'iud',
    state: 'sdld_c51rDtlsss',
    b_vsn: true,
    dd_elmDefss: {
      c51r: {
        elm: 'c51r',
        b_setPageKey: false,
        od_insDats: _dd_datss => {
          let _d = {
//            c51rb51k: _dd_datss.c51r.d_flds.c51rb51k ?? '',
            c51rc11s: _dd_datss.c51r.d_flds.c51rc11s ?? '',
            c51ri11s: _dd_datss.c51r.d_flds.c51ri11s ?? '',
          };
          return _d;
        },
      },
    },
  }),
];


render() {

//ff.l('c51v 354: {}'.f(global.t?.state.sdld_c51rDtlsss));

  return (
    ce.c(ce.RootDtl, {
      key: -10,
      d_hdrs: {
        pfx: 
          (global.t?.state.sgc_pnlMode == 'list') ?
            '文章変更・その他設定'
          : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'show') ?
            '文章変更・その他設定'
          : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'edit') ?
            '文章変更・その他設定'
          : (global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'new') ?
            '文章変更・その他設定'
          : null,
        d_subs: 
          ff.i(global.t?.state.sgc_pageMode, ['new', 'edit']) == false ?
            {
              iconName: 'users',
              pfx: 'ユーザ切替',
              o_onPrs: () => {
                let _d_pageInfs = {
                  sgc_pageRole: global.t?.state.sgc_pageRole,
                  sgc_pageName: 'c00v2a',
                  sgc_pageMode: 'show',
                };
                cf.myRN_move_fwd(_d_pageInfs);
              },
            }
          : null,
      },
      d_bdys: {
        l_clds: [

          ce.c(ce.Pnl, {
            key: -1,
            mode: 'list',
            b_vsb: (global.t?.state.sgc_pnlMode == 'list') ? true : false,
            d_hdrs: {
              d_ctrs: {
                l_clds: [
                  ce.c(ce.Inp, cf.f('c30rc31s', {
                    pfx: '設定項目',
                    type: 'Inp',
                    key: -1, 
                    b_vsb: true,
                    b_edit: true,
                    b_row: true,
                    b_rvs: true,
                    state: 's_word',
                  })),
                  ce.c(ce.BtnIconPfx, {
                    key: -5, 
                    b_vsb: true,
                    b_row: true,
                    iconName: 'search',
                    pfx: '検索',
                    o_onPrs: () => global.t?.op_loadListAll(),
                  }),
                ],
              },
            },
            d_bdys: {
              l_clds: [

                ce.c(ce.Box, {
                  key: -10,
                  n_mgnTop: ic.s(1),
                  d_stlCtas: {
                    marginBottom: ic.s(1),
                  },
                }, [
                  ce.c(cr.InpTree, {
                    key: -12,
                    state: 'sdld_c51rListsss',
                    dd_elmDefss: {
                      c51r: {
                        elm: 'c51r',
                        b_row: true,
                        b_ttl: false,
                        b_rootHdr: true,
                        d_stlHdrRows: {
                          height: ic.s(1.8),
                        },
                        d_stlBdyRows: {
                          height: ic.s(2.2),
                          marginTop: ic.s(0.2)
                        },
                        dd_fldDefss: cf.myRN_getFldDefs([
                          cf.f('c51rc11s', {
                            b_key: true,
                            d_hdrs: { n_w: ic.s(8), },
                            d_bdys: { n_w: ic.s(8), },
                          }),
                          cf.f('c50rk11s', {
                            d_hdrs: { n_w: ic.s(10), },
                            d_bdys: { n_w: ic.s(10), },
                          }),
                          cf.f('c50rc31s', {
                            d_hdrs: { n_w: ic.s(22), },
                            d_bdys: { n_w: ic.s(22), },
                          }),
                        ]),
                      },
                    },
                  }),
                ])

              ],
            },
            d_btms: {
              l_clds: [
                ce.c(ce.Box, {
                  key: -2,
                  stlCta: {
                    minHeight: ic.s(2 * 2),
                    width: ic.gn_minBdyW,
                    flexDirection: 'row',
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    marginTop: ic.s(0.5), // 20211202
                    marginBottom: ic.s(0.5), // 20211202
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }
                }, [
                  ce.c(ce.Btn, {
                    key: -20,
                    pfx: '前の画面に戻る',
                    stlBtn: {
                      width: ic.s(8),
                      backgroundColor: ic.g_ccdHN,
                      borderColor: ic.g_ccdHN,
                    },
                    o_onPrs: () => {
                      let _d_pageInfs = {
                        sgc_pageRole: global.t?.state.sgc_pageRole,
                        sgc_pageName: 'iStg1',
                        sgc_pageMode: 'show',
                      }; 
                      cf.myRN_move_fwd(_d_pageInfs);
                    },
                  }),
                ])
              ],
            },
          }),

          ce.c(ce.Pnl, {
            key: -20,
            mode: 'dtl',
            b_vsb: (global.t?.state.sgc_pnlMode == 'dtl') ? true : false,
            d_hdrs: {
            },
            d_hdrs: {
              d_htys: {
                elm: 'c51r',
                ld_iss: global.t?.state.sdld_c51rVsnListsss?.c51r,
                op_loadDtl: c51v.op_loadDtl,
              },
            },
            d_btms: {
            },
            d_bdys: {
              l_clds: [

                ce.c(ce.Box, {
                  key: -10,
                  n_mgnTop: ic.s(1),
                  d_stlCtas: {
                    marginBottom: ic.s(1),
                  },
                }, [
                  ce.c(cr.InpTree, {
                    key: -12,
                    state: 'sdld_c51rDtlsss',
                    dd_elmDefss: {
                      c51r: {
                        elm: 'c51r',
                        b_row: false,
                        b_ttl: true,
                        b_subHdr: false,
                        d_cmns: {
                          n_cnt: 1,
                        },
                        dd_fldDefss: cf.myRN_getFldDefs([
                          cf.f('c51rc11s', {
                            b_edit: false,
                            d_hdrs: { n_w: ic.s(8), },
                            d_bdys: { n_w: ic.s(8), },
                          }),
                          cf.f('c50rk11s', {
                            b_edit: false,
                            n_col: 20,
                            d_hdrs: { n_w: ic.s(8) },
                            d_bdys: { n_w: ic.s(20) },
                          }),
                          cf.f('c50rc31s', {
                            b_edit: false,
                            n_col: 20,
                            d_hdrs: { n_w: ic.s(8) },
                            d_bdys: { n_w: ic.s(20) },
                          }),
                          cf.f('c51ri11s', {
                            o_type: _d_dats => {
                              let _type = 
                                _d_dats.d_flds.c50rt11s == 'Pck' ?
                                  'Pck'
                                : 'Inp';
                              return _type;
                            },
                            old_iss: _d_dats => {
                              if (ff.f(_d_dats.d_flds.c50ri11s)) {
                                let _ld_iss = ff.j(_d_dats.d_flds.c50ri11s);
                                return _ld_iss;
                              }
                              else {
                                return null;
                              }
                            },
                            on_col: _d_dats => {
                              return _d_dats.d_flds.c50ri12i;
                            },
                            d_hdrs: { 
                              n_w: ic.s(8), 
                              d_stlPfxs: {
                                marginTop: ic.s(0.5),
                              },
                            },
                            od_bdys: _d_dats => {
                              let _d = { 
                                n_w: ic.s(_d_dats.d_flds.c50ri12i), 
                                n_h: ic.s(_d_dats.d_flds.c50ri11i * 2)
                              };
                              return _d;
                            },
                            ob_mln: _d_dats => {
                              let _b = (_d_dats.d_flds.c50rt11s == 'Inp2') ? true : false;
                              return _b;
                            },
                            o_stlInp: _d_dats => {
                              let _d = 
                                (_d_dats.d_flds.c50rt11s == 'Inp2') ? 
                                  {
                                    height: ic.s(_d_dats.d_flds.c50ri11i * 2)
                                  }
                                : null;
                              return _d;
                            }, 
                            d_stlCmns: {
                              alignItems: 'flex-start',
                            },
                          }),
                        ]),
                      },
                    },
                  }),
                ]),
              ],
            },
          }),

        ],
      }
    })
  );
}

}
